import React from "react";
import { Creator } from "../../../../api/staff";
import { Typography } from "../../../../components";

interface CreatorCreatedAtCellProps {
  creator: Creator;
}

const CreatorCreatedAtCell: React.FC<CreatorCreatedAtCellProps> = ({ creator }) => {
  // Format date from ISO string to readable format
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="flex items-center">
      <Typography variant="body2" className="text-[#11181C] text-[14px] font-medium">
        {formatDate(creator.created_at)}
      </Typography>
    </div>
  );
};

export default CreatorCreatedAtCell;
